import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-recharge",
  "use": "icon-recharge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-recharge\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 192H192c-17.67 0-32 14.33-32 32v576c0 17.67 14.33 32 32 32h640c17.67 0 32-14.33 32-32V224c0-17.67-14.33-32-32-32z m-608 64h576v64H224v-64z m576 512H224V384h576v384z\" p-id=\"10763\" /><path d=\"M416 608c-17.67 0-32 14.33-32 32s14.33 32 32 32h64v32c0 17.67 14.33 32 32 32s32-14.33 32-32v-32h64c17.67 0 32-14.33 32-32s-14.33-32-32-32h-64v-16h64c17.67 0 32-14.33 32-32s-14.33-32-32-32h-34.74l57.37-57.37c12.5-12.5 12.5-32.76 0-45.25-12.5-12.5-32.76-12.5-45.26 0L512 498.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0-12.5 12.5-12.5 32.76 0 45.25L450.74 528H416c-17.67 0-32 14.33-32 32s14.33 32 32 32h64v16h-64z\" p-id=\"10764\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/recharge.svg
// module id = 3guZ
// module chunks = 34